export default "__VITE_ASSET__C52SYU05__"